import type { PatientUserInfo } from "@phurshell/psiapp-frontend-core/domain";
import { defineStore } from "pinia";

export const useUserInfoStore = defineStore("userInfo", {
  state: (): { user_info: PatientUserInfo | null } => ({ user_info: null }),
  persist: true,
  actions: {
    save(params: PatientUserInfo) {
      this.user_info = params;
    },
    update(params: Partial<PatientUserInfo>) {
      this.user_info = { ...(this.user_info || {}), ...params } as PatientUserInfo;
    },
    destroy() {
      this.user_info = null;
    },
  },
});
